import { BloodIcon } from "../icons";
import List from "./List";

export default {
  icon: BloodIcon,
  options: {
    group: "blood",
    mergeFilters: false,
    accessible: ({ user }) =>
      user.permissions.indexOf("blood-bag-working/list") !== -1,
  },
  list: List,
};
